import Ayah from './Ayah';
import Ibu from './Ibu';
import Pendukung from './Pendukung';
import Pribadi from './Pribadi';
import Wali from './Wali';

export {
    Ayah,
    Ibu,
    Pendukung,
    Pribadi,
    Wali
};